<div>
  <div *ngIf="field.editable">
    <ng-select
      [(ngModel)]="selectedItem"
      [ngClass]="{'ng-select-disabled': disabled}"
      [items]="dropdownList"
      (change)="onChange()">
    </ng-select>
  </div>
  <div *ngIf="!field.editable && field.value">
    {{ field.value }}
  </div>
</div>
